import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { connectModal as reduxModal } from 'redux-modal';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';

import Alert from 'ui/common/alert';
import { importLinkedInPdf } from 'store/features/users/actions';
import {
  selectIsImportingLinkedInPdf,
  selectLinkedInPdfImportError,
} from 'store/features/users/selectors';
import linkedInImage from 'resources/linkedIn-import/import-linked-in-instruction.png';
import FileUploadButton from 'ui/common/rebranding/components/Button/FileUploadButton';

const { request: importLinkedInPdfRequest } = importLinkedInPdf;

const messages = defineMessages({
  title: {
    id: 'import-linkedin.title',
    defaultMessage: 'Import Instructions',
  },
  listOne: {
    id: 'import-linkedin.listOne',
    defaultMessage: 'Login to your LinkedIn page and go to view profile.',
  },
  listTwo: {
    id: 'import-linkedin.listTwo',
    defaultMessage: 'Click on the "More..." button and save the pdf.',
  },
  listThree: {
    id: 'import-linkedin.listThree',
    defaultMessage:
      'Click on the import* pdf button below and choose the LinkedIn pdf file you downloaded.',
  },
  listFour: {
    id: 'import-linkedin.listFour',
    defaultMessage: 'Verify your details',
  },
  noteOne: {
    id: 'import-linkedin.noteOne',
    defaultMessage:
      '* At present, only work experience data is imported. Please add your education entries manually',
  },
  noteTwo: {
    id: 'import-linkedin.nodeTwo',
    defaultMessage: '* If you save PDF multiple times, data will be duplicated.',
  },
  import: {
    id: 'import-linkedin.import',
    defaultMessage: 'Import pdf',
  },
  cancel: {
    id: 'import-linkedin.cancel',
    defaultMessage: 'Cancel',
  },
});

export const MODAL_NAME = 'import-linkedin-modal';

class LinkedInModal extends Component {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  handleLinkedInPdfSelect(e) {
    let file = e.target && e.target.files && e.target.files[0];
    if (file) this.props.importLinkedInPdfRequest({ file }, MODAL_NAME);
  }

  modalBody() {
    const { importing, error, intl: { formatMessage } } = this.props;

    return (
      <ModalBody>
        <ol className="mb-0 pb-3">
          <li>{formatMessage(messages.listOne)}</li>
          <li className="pb-3">{formatMessage(messages.listTwo)}</li>
          <img className="img-thumbnail mx-auto" width="100%" src={linkedInImage} alt="thumbnail" />
          <li
            className="pt-3"
            dangerouslySetInnerHTML={{ __html: formatMessage(messages.listThree) }}
          />
          <li className="pt-3">{formatMessage(messages.listFour)}</li>
        </ol>

        <div className="pl-4 pt-4">
          <small>
            <div>{formatMessage(messages.noteOne)}</div>
            <div>{formatMessage(messages.noteTwo)}</div>
          </small>
        </div>

        {!importing &&
          error && (
            <Alert color="danger" inverse>
              {error.id && error.defaultMessage ? formatMessage(error) : error}
            </Alert>
          )}
      </ModalBody>
    );
  }

  render() {
    const { show, intl: { formatMessage }, handleHide } = this.props;
    const modalBody = this.modalBody();

    return (
      <Modal isOpen={show}>
        <ModalHeader toggle={handleHide}>{formatMessage(messages.title)}</ModalHeader>
        {modalBody}
        <ModalFooter>
          <FileUploadButton
            id="import-linkedin-pdf-button"
            onHandleInputChange={e => this.handleLinkedInPdfSelect(e)}
            accept="application/pdf"
          >
            {formatMessage(messages.import)}
          </FileUploadButton>
        </ModalFooter>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    importing: selectIsImportingLinkedInPdf(state),
    error: selectLinkedInPdfImportError(state),
  };
}

const mapDispatchToProps = {
  importLinkedInPdfRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxModal({
    name: MODAL_NAME,
  })(injectIntl(LinkedInModal))
);
